export const MARBLE_ANNOUNCEMENT_KEY = 'marble-app-announcement-v1-seen'
export const AUTOMATIC_PROMOTION_STATE_KEY = 'automatic-promotion-opened'

/** Campaign-specific: an old newsletter answer must not hide the new collection. */
export function useMarbleAnnouncement() {
  const open = useState('marble-announcement-open', () => false)
  const mounted = useState('marble-announcement-mounted', () => false)
  const pending = useState('marble-announcement-pending', () => false)
  const shownThisVisit = useState('marble-announcement-shown', () => false)
  const automaticPromotionShown = useState(AUTOMATIC_PROMOTION_STATE_KEY, () => false)

  function isEligible(): boolean {
    if (typeof window === 'undefined' || shownThisVisit.value || automaticPromotionShown.value)
      return false
    try {
      return window.localStorage.getItem(MARBLE_ANNOUNCEMENT_KEY) !== '1'
    }
    catch {
      // The shared state still limits blocked-storage browsers to this visit.
      return true
    }
  }

  /** A deliberate announcement-bar click can reopen an already-seen campaign. */
  function show(options: { manual?: boolean } = {}): boolean {
    pending.value = false
    if (typeof window === 'undefined' || (!options.manual && !isEligible()))
      return false
    mounted.value = true
    open.value = true
    return true
  }

  /** Called by the dialog once visible, never when merely loading its chunk. */
  function markShown(): void {
    if (!open.value || shownThisVisit.value)
      return
    shownThisVisit.value = true
    automaticPromotionShown.value = true
    try {
      window.localStorage.setItem(MARBLE_ANNOUNCEMENT_KEY, '1')
    }
    catch {
      // The in-memory state above remains valid for client-side navigation.
    }
  }

  function dismiss(): void {
    open.value = false
    pending.value = false
  }

  return { open, mounted, pending, shownThisVisit, isEligible, show, markShown, dismiss }
}
